export interface MapFocusConfig {
    routeId?: number;
    routeType?: string;
    twuid?: string;
}

/**
 * Typed view of the configuration the Razor view emits on the #mapData element.
 */
export interface IMapConfig {
    isAuthenticated: boolean;
    canEditGpx: boolean;
    wmsUrl: string;
    osmApiKey: string;
    isMember: boolean;
    infoClickProw: number;
    showHidden: number;
    isTitheMapsWales: boolean;
    siteId: string;
    focusConfig: MapFocusConfig | null;
    loginUrl: string;
    registerUrl: string;
}

export function readMapConfig(): IMapConfig {
    const mapData = $("#mapData");

    const focusRouteIdRaw = mapData.data("focusRouteId");
    const focusRouteType = mapData.data("focusRouteType");
    const focusTwuid = mapData.data("focusTwuid");

    const focusRouteId = focusRouteIdRaw ? Number(focusRouteIdRaw) : undefined;
    const hasFocusTwuid = typeof focusTwuid === "string" && focusTwuid.length > 0;
    const focusConfig: MapFocusConfig | null = hasFocusTwuid ? {
        routeId: typeof focusRouteId === "number" && !isNaN(focusRouteId) ? focusRouteId : undefined,
        routeType: focusRouteType as string,
        twuid: focusTwuid as string
    } : null;

    return {
        isAuthenticated: mapData.data("auth"),
        canEditGpx: mapData.data("canEditGpx"),
        wmsUrl: mapData.data("wmsurl"),
        osmApiKey: mapData.data("osmApiKey"),
        isMember: mapData.data("isMember"),
        infoClickProw: mapData.data("infoClickProw"),
        showHidden: mapData.data("showHidden"),
        isTitheMapsWales: mapData.data("titheMapsWales"),
        siteId: mapData.data("siteId"),
        focusConfig: focusConfig,
        loginUrl: "login",
        registerUrl: "register"
    };
}
